<template>
  <div
    ref="zjdgx"
    class="influencer"
  >
    <div class="bread-crumb">
      Influencers
    </div>
    <h2>Influencers</h2>
    <a-spin :spinning="isLoading">
      <a-tabs
        v-model:activeKey="activeTab"
        :destroy-inactive-tab-pane="true"
        @change="onTabChange"
      >
        <a-tab-pane
          key="registered"
          tab="Registered"
        >
          <Registered
            :ref="registeredTab"
            :data="influencersList"
            @setShowLogModalId="setShowLogModalId"
            @toggleStatus="toggleStatus"
            @getList="getList"
          />
        </a-tab-pane>
        <a-tab-pane
          v-for="page in ['Approved', 'Pending', 'Rejected']"
          :key="page.toLowerCase()"
          :tab="page"
        >
          <OtherStatus
            :ref="otherStatusTab"
            :data="influencersList"
            :active-page="page"
            @getList="getList"
            @setLoading="setLoading"
            @toggleStatus="toggleStatus"
            @setShowLogModalId="setShowLogModalId"
            @changeReviewStatus="changeReviewStatus"
          />
        </a-tab-pane>
        <a-tab-pane
          key="invitation"
          tab="Invitation"
        >
          <Invitation
            :ref="invitationTab"
            @setLoading="setLoading"
            @setShowLogModalId="setShowLogModalId"
          />
        </a-tab-pane>
      </a-tabs>
    </a-spin>
    <LogModal
      v-if="showLogModal"
      :id="showLogId"
      :container="$refs.zjdgx"
      @hideLogModal="hideLogModal"
    />
  </div>
</template>

<script setup>
import { ref } from 'vue'
import { useRoute } from 'vue-router'
import LogModal from './logModal.vue'
import OtherStatus from './otherStatus.vue'
import Invitation from './invitation.vue'
import { message } from 'ant-design-vue'
import Registered from './registered.vue'
import { influencers } from '../../server/index'

const router = useRoute()
const isLoading = ref(false)
const showLogId = ref(-1)
const showLogModal = ref(false)
const influencersList = ref([])
const registeredTab = ref(null)
const invitationTab = ref(null)
const otherStatusTab = ref(null)
const activeTab = ref(router.params.activeTab || 'registered')

const getList = (params, cb) => {
  isLoading.value = true

  Object.keys(params).forEach((key) => {
    if (params[key] == null || params[key] == '' || params[key] == undefined) {
      delete params[key]
    }
  })

  influencers.getList(params).then((res) => {
    isLoading.value = false
    influencersList.value = res.data

    if (cb) {
      cb(res)
    }
  })
}

function setLoading(loading) {
  isLoading.value = loading
}

function toggleStatus(index, user) {
  isLoading.value = true
  influencers
    .changeStatus({ id: user.id, linkToolStatus: user.linkToolStatus })
    .then((res) => {
      isLoading.value = false

      if (res.success) {
        influencersList.value[index].linkToolStatus = user.linkToolStatus
        message.success('Link tool status successfully changed.')
      }
    })
}

// log相关代码
const setShowLogModalId = (id) => {
  showLogId.value = id
  showLogModal.value = true
}
const hideLogModal = () => {
  showLogId.value = -1
  showLogModal.value = false
}

function onTabChange(activeKey) {
  history.pushState(
    null,
    null,
    location.href.replace(location.hash, '#/influencers/' + activeKey)
  )
}

function changeReviewStatus(ids, status, cb) {
  influencers
    .changeReviewStatus({
      ids,
      reviewStatus: status,
    })
    .then(cb)
}
</script>

<style lang="less" scoped>
.influencer {
  :deep(.search) {
    padding: 20px;
    margin-bottom: 20px;
    .btns {
      width: 100%;
      text-align: right;
    }
    .ant-btn {
      margin-left: 20px;
    }
    .ant-form-item {
      margin-bottom: 0;
    }
  }
}
</style>